import React from "react";
import { usePermission } from "src/context/PermissionContext";

interface PermissionRestrictedComponentProps {
  permission: number | null;
  children: React.ReactElement;
}

const PermissionRestrictedComponent: React.FC<
  PermissionRestrictedComponentProps
> = ({ permission, children }) => {
  const hasPermission = usePermission(permission);

  return <>{hasPermission ? children : null}</>;
};

export default PermissionRestrictedComponent;
